<template>
  <v-card flat>
    <v-card-title> Общие свойства товаров StoreHouse </v-card-title>
    <v-card-text>
      <v-fade-transition>
        <v-banner
          v-if="!defaultOptionsOk"
          color="warning"
          icon="mdi-alert"
          class="mb-5 black--text"
          outlined
          dark
        >
          Не выставлены общие свойства товаров
        </v-banner>
      </v-fade-transition>
      <CategorySelectComponent
        label="Категория товаров"
        @change="
          (val) =>
            updateUploadOption({
              key: `goodsCategoryRid`,
              val: val !== undefined ? val : null,
            })
        "
        :value="
          gCategories.find((e) => e.rid == uploadOptions.goodsCategoryRid)
        "
        :items="gCategories"
      />
      <CategorySelectComponent
        label="Бух. категория товаров"
        @change="
          (val) =>
            updateUploadOption({
              key: `accountingCategoryRid`,
              val: val !== undefined ? val : null,
            })
        "
        :value="
          aCategories.find((e) => e.rid == uploadOptions.accountingCategoryRid)
        "
        :items="aCategories"
      />
      Родительская группа товаров
      <CustomTree
        :items="gGroups"
        :updateFunc="updateUploadOption"
        :createFunc="createGroup"
        updateKey="groupRootRid"
        :selected="uploadOptions.groupRootRid"
      />
    </v-card-text>
    <v-card-title> Опции загрузки </v-card-title>
    <v-card-text class="flex-column align-start flex-grow-0">
      <v-switch
        :value="uploadOptions.uploadCals"
        label="Загружать БЖУ"
        @change="
          (e) => updateUploadOption({ key: `uploadCals`, val: e == true })
        "
        dense
      ></v-switch>
      <v-switch
        :value="uploadOptions.uploadMinMaxAmounts"
        label="Загружать мин. и макс. остатки"
        class="flex-grow-0"
        @change="
          (e) =>
            updateUploadOption({ key: `uploadMinMaxAmounts`, val: e == true })
        "
        dense
      ></v-switch>
      <v-switch
        :value="uploadOptions.uploadPrecent"
        label="Загружать Проценты Обработки"
        @change="
          (e) => updateUploadOption({ key: `uploadPrecent`, val: e == true })
        "
        dense
      ></v-switch>
    </v-card-text>
    <v-card-title> Соотношение столбцов </v-card-title>
    <v-card-text>
      <v-select
        label="Разделитель пути"
        style="max-width: 350px !important"
        :items="pathSeparators"
        item-text="val"
        item-value="val"
        :value="pathSep"
        @change="updatePathSep"
      />
      <v-checkbox
        dense
        :false-value="0"
        v-model="skipLine"
        label="Первая строка это заголовок таблицы, а не товар"
        class="shrink"
      />
      <ColumnsComponent />
    </v-card-text>
  </v-card>
</template>

<script>
import ColumnsComponent from "./GoodsColumnsComponent";
import CategorySelectComponent from "../CategorySelectComponent";
import CustomTree from "../CustomTree";

import { mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    pathSeparators: [
      { val: "/" },
      { val: "\\" },
      { val: "-" },
      { val: "_" },
      { val: "." },
      { val: "@" },
    ]
  }),
  computed: {
    skipLine:{
      set(newValue){
        this.updateSkip(newValue ? 1 : 0)
      },
      get(){
        return this.skip
      }
    },
    ...mapGetters([
      "uploadOptions",
      "skip",
      "aCategories",
      "gCategories",
      "gGroups",
      "defaultOptionsOk",
      "defaultColumnsOk",
      "caloryOk",
      "amountsOk",
      "precentlesOk",
      "pathSep",
    ]),
    allOk() {
      return (
        this.defaultColumnsOk &&
        this.defaultOptionsOk &&
        this.caloryOk &&
        this.amountsOk &&
        this.precentlesOk
      );
    },
    unwatched() {
      return (
        this.defaultColumnsOk &&
        this.defaultOptionsOk &&
        this.caloryOk &&
        this.amountsOk &&
        this.precentlesOk
      );
    },
  },
  methods: {
    ...mapActions([
      "updateGCat",
      "updateGACat",
      "updateGGroup",
      "updateUploadOption",
      "updateSkip",
      "createGroup",
      "updatePathSep",
      "parseUnits",
    ])
  },
  components: {
    ColumnsComponent,
    CustomTree,
    CategorySelectComponent,
  },
  watch: {
    allOk(newVal) {
      if (newVal == true) {
        this.$emit("cant-continue", false);
      } else {
        this.$emit("cant-continue", true);
      }
    }
  },
  mounted() {
    if (!this.unwatched) {
      this.$emit("cant-continue", true);
    }
  },
};
</script>